export default __webpack_public_path__ + "static/media/pr_c_12.0242cc0d.jpg";